var map = {
	"./categoryDescription/default/aboriginal-health-services.md": 1231,
	"./categoryDescription/default/ageing.md": 1232,
	"./categoryDescription/default/alcohol-tobacco-and-other-drugs.md": 1233,
	"./categoryDescription/default/allied-health.md": 1234,
	"./categoryDescription/default/categoryInfo-allied.md": 1235,
	"./categoryDescription/default/child-youth-and-family-health.md": 1236,
	"./categoryDescription/default/community-health-and-medical.md": 1237,
	"./categoryDescription/default/dental-and-oral-health.md": 1238,
	"./categoryDescription/default/general-health-services.md": 1239,
	"./categoryDescription/default/general-practice.md": 1240,
	"./categoryDescription/default/health-screening-services.md": 1241,
	"./categoryDescription/default/hearing-services.md": 1242,
	"./categoryDescription/default/mental-health-services.md": 1243,
	"./categoryDescription/default/multi-cultural-and-refugee-health.md": 1244,
	"./categoryDescription/default/palliative-care.md": 1245,
	"./categoryDescription/default/pregnancy-maternity-and-newborn.md": 1246,
	"./categoryDescription/default/psychiatric-services.md": 1247,
	"./categoryDescription/default/sexual-and-reproductive-health.md": 1248,
	"./categoryDescription/default/specialists.md": 1249,
	"./static/default/about.md": 1250,
	"./static/default/footer-dev.md": 1251,
	"./static/default/home.md": 1252,
	"./static/default/kitchensink.md": 1253,
	"./static/default/support.md": 1254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;